/* eslint-disable no-param-reassign */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { GetTicketDetails, handleImpressionsTrack, ReOpenTicketSubmit } from '../../api';
import useAlert from '../../hooks/useAlert';
import { useAppState } from '../../contexts/appState';
import { useAuth } from '../../contexts/auth';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import { onClickEvent } from '../../lib/gaAnalytics';
import { formatCreatedOn } from '../../lib/time';
import {
  CheckingValidComment,
  clickTracker,
  defaultEnableBtnStyles,
  getProjectId,
  getUserType,
  trackUserType,
} from '../../lib/common';
import CommonPopup from '../Popups/CommonPopup';
import GenioModal from '../Genio/GenioModal/GenioModal';
import CommentsPopup from '../Popups/CommentsPopup';
import styles from '../../styles/Tickets.module.scss';
import styles2 from '../../styles/Accordion.module.scss';
import { usePopup } from '../../hooks';
import { Tooltip } from '../common';

export default function MyTickets({
  reloadMyTickets,
  myTicketsData,
  loading,
  id,
  hideViewAll,
  handleOnLanding,
  trackPage = '',
}) {
  const projectId = getProjectId();
  const [appState] = useAppState();
  const [authState] = useAuth();
  const { type, selectedBusiness } = authState;
  const { popupObj } = appState;
  let contractType = '';
  const storedValue = sessionStorage.getItem('contractType');
  if (projectId === 'csportal') {
    try {
      contractType = JSON.parse(storedValue);
    } catch (e) {
      contractType = storedValue;
    }
  } else {
    contractType = storedValue;
  }
  const page = 'CSMy Tickets';

  const [commentsData, setCommentsData] = useState([]);
  const [selectedTicketData, setSelectedTicketData] = useState([]);
  const [dispositionComment, setDispositionComment] = useState('');
  const [setAlert] = useAlert();
  const [enableGrievance, setEnableGrievance] = useState('');
  const [showGrievanceData, setShowGrievanceData] = useState(false);
  const navigate = useNavigate();
  const reopenTicketRef = useRef(null);
  const commentsRef = useRef(null);
  const genioReopenRef = useRef(null);
  const [setPopup] = usePopup();
  const myTicketsRef = useRef(null);
  const [hasLogged, setHasLogged] = useState(false);
  const [haveSubmitted, setHaveSubmitted] = useState(false);
  const [aiSummary, setAiSummary] = useState('');

  const handleDispositionCommentSubmit = async (fileData = []) => {
    setHaveSubmitted(true);
    const hasGenioDocument = projectId === 'genio' && selectedTicketData?.ticket_id.startsWith('CCC');
    if (projectId === 'csportal') {
      onClickEvent(`${id === 'allTickets' ? `${page}-${type}` : 'Grievance ticket'}-Submit`, 'Submit', 'Submit');
    }
    const documentsArr = selectedTicketData?.document?.length > 0 ? selectedTicketData?.document : [];
    const filesArr = [];
    if (hasGenioDocument && fileData?.length > 0) {
      fileData.forEach((item) => {
        filesArr.push({
          nm: 'REOPEN IMAGE',
          url: item.url,
        });
      });
      filesArr.push(...documentsArr);
    }
    if (CheckingValidComment(dispositionComment) || hasGenioDocument) {
      const updatedData = {
        disposition: enableGrievance ? 'GRIEVANCE RAISED' : 'REOPEN',
        issue_comment: dispositionComment?.trim(),
        status: enableGrievance ? selectedTicketData?.status : 'OPEN',
        gr_raised: enableGrievance ? 1 : 0,
      };
      if (hasGenioDocument) {
        updatedData.document = fileData?.length > 0 ? filesArr : documentsArr || [];
      }
      const params = {
        ticket_id: selectedTicketData?.ticket_id || '',
        update_data: updatedData,
        upby_id: selectedTicketData.alloc_empid,
        upby_nm: selectedTicketData.alloc_empnm,
      };
      const res = await ReOpenTicketSubmit(params);
      if (res.errorCode === 0) {
        setAlert({
          message: res?.result?.msg || '',
          status: true,
        });
        await reloadMyTickets();
      } else {
        setAlert({
          message: res?.message || res?.result?.msg || 'Something went wrong',
          status: false,
        });
      }
    }
    setDispositionComment('');
    setPopup({});
    document.body.style.overflow = 'unset';
    setHaveSubmitted(false);

    if (projectId === 'genio') {
      await clickTracker(`${enableGrievance ? 'grievance_submit' : 'reopen_submit'}`, 'geniocs_mytickets');
    } else if (trackUserType?.[contractType]) {
      await clickTracker(
        `${enableGrievance ? 'grievance_submit' : 'reopen_submit'}`,
        contractType === 'user'
          ? id === 'mytickets_page'
            ? 'User_Mytickets_page'
            : 'User_Mytickets'
          : `${trackUserType?.[contractType]}_${
              id === 'allTickets' ? 'mytickets' : id === 'mytickets_page' ? 'mytickets_page' : ''
            }`,
      );
    }
    if (getUserType?.[contractType]) {
      onClickEvent(
        `CSMain-${getUserType?.[contractType]}-${enableGrievance ? 'Grievance redressal' : 'reopen'}-submit`,
        `${getUserType?.[contractType]}-${enableGrievance ? 'Grievance redressal' : 'reopen'}-submit`,
        `${getUserType?.[contractType]}-${enableGrievance ? 'Grievance redressal' : 'reopen'}-submit`,
      );
    }

    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${enableGrievance ? 'ticketcreationsubmitGR' : 'reopensubmit'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = ``;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }

    reloadMyTickets();
  };

  const handleReopenClick = async (data) => {
    onClickEvent(`${`${page}-${type}`}-Re-open`, 'Re-open', 'Re-open');
    setSelectedTicketData(data);
    if (projectId === 'genio' && data?.ticket_id.startsWith('CCC')) {
      document.body.style.overflow = 'hidden';
      setPopup({
        open: true,
        popupType: 'genioReopenTicket',
      });
    } else {
      document.body.style.overflow = 'hidden';
      setPopup({
        open: true,
        popupType: 'reopenTicket',
        heading: 'To understand better, Please help us with the reason:',
        subHeading: '',
        placeholder: 'What went wrong with last given solution?',
      });
    }

    if (projectId === 'genio') {
      await clickTracker('reopen', 'geniocs_mytickets');
    } else if (trackUserType?.[contractType]) {
      await clickTracker(
        'reopen',
        contractType === 'user'
          ? id === 'mytickets_page'
            ? 'User_Mytickets_page'
            : 'User_Mytickets'
          : `${trackUserType?.[contractType]}_${
              id === 'allTickets' ? 'mytickets' : id === 'mytickets_page' ? 'mytickets_page' : ''
            }`,
      );
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_reopen`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = ``;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
  };

  const handleViewCommentsClick = async (row) => {
    const summary = row?.ai_resolution && projectId === 'genio' ? JSON.parse(row?.ai_resolution).summary : '';
    if (row?.alloc_empid === 'AI101') {
      setAiSummary(summary);
    } else {
      setAiSummary('');
    }

    if (projectId === 'csportal') {
      onClickEvent(`${`${page}-${type}`}-View comments`, 'View comments', 'View comments');
    }
    if (getUserType?.[contractType]) {
      onClickEvent(
        `CSMain-${getUserType?.[contractType]}-my tickets-view comments`,
        `${getUserType?.[contractType]}-my tickets-view comments`,
        `${getUserType?.[contractType]}-my tickets-view comments`,
      );
    }
    try {
      const res = await GetTicketDetails(row?.ticket_id, projectId);
      let updatedCommentsArr = [];
      if (projectId === 'genio') {
        updatedCommentsArr = (res?.result && res?.result.length > 0 && res?.result) || [];
      } else {
        updatedCommentsArr = res?.result && res?.result?.length > 0 ? res?.result : [];
      }
      if (row?.issue_comment && row.issue_comment.trim() !== '') {
        updatedCommentsArr.push({
          agentId: row?.alloc_empid || null,
          agentName: row?.nm || row?.compnm || '',
          comment: row?.issue_comment,
          document: row?.document || [],
          oldComment: null,
          type: 'issue_comment',
          updatedAt: formatCreatedOn(row?.createdOn),
        });
      }
      if (updatedCommentsArr?.length === 0) {
        let message = 'No comments history';
        if (projectId !== 'genio' && summary.summary === '') {
          message = 'No suggested resolution found';
        }
        setAlert({
          message,
          status: false,
        });
      } else {
        const finalArr = [];
        updatedCommentsArr.forEach((element) => {
          if (element?.type === 'issue_comment') {
            element.agentName = row?.nm || '';
          }
          finalArr.push(element);
        });
        setCommentsData(updatedCommentsArr);
        document.body.style.overflow = 'hidden';
        setPopup({
          open: true,
          popupType: 'ViewComments',
          heading: 'Comment History',
          trackerId: 'viewcomments',
        });
      }
    } catch (e) {
      console.log('Error fetching view comments', e);
    }

    if (projectId === 'genio') {
      await clickTracker('viewcomments', 'geniocs_mytickets');
    } else if (trackUserType?.[contractType]) {
      await clickTracker(
        'viewcomments',
        contractType === 'user'
          ? id === 'mytickets_page'
            ? 'User_Mytickets_page'
            : 'User_Mytickets'
          : `${trackUserType?.[contractType]}_${
              id === 'allTickets' ? 'mytickets' : id === 'mytickets_page' ? 'mytickets_page' : ''
            }`,
      );
    }

    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `view_comments`;
      handleOnLanding(liVal, liTrd, 'view_comments');
    }
  };

  const handleClosePopup = async (commentsPopup = 0) => {
    document.body.style.overflow = 'unset';
    setDispositionComment('');

    if (projectId === 'genio') {
      await clickTracker(
        `${
          commentsPopup
            ? 'viewcomments_cancel'
            : enableGrievance
              ? 'grievance_cancel'
              : popupObj?.popupType === 'reopenTicket'
                ? 'reopen_cancel'
                : ''
        }`,
        'geniocs_mytickets',
      );
    } else if (trackUserType?.[contractType]) {
      await clickTracker(
        `${
          commentsPopup
            ? 'viewcomments_cancel'
            : enableGrievance
              ? 'grievance_cancel'
              : popupObj?.popupType === 'reopenTicket'
                ? 'reopen_cancel'
                : ''
        }`,
        contractType === 'user'
          ? id === 'mytickets_page'
            ? 'User_Mytickets_page'
            : 'User_Mytickets'
          : `${trackUserType?.[contractType]}_${
              id === 'allTickets' ? 'mytickets' : id === 'mytickets_page' ? 'mytickets_page' : ''
            }`,
      );
    }
    if (getUserType?.[contractType]) {
      onClickEvent(
        `CSMain-${getUserType?.[contractType]}-${
          enableGrievance
            ? 'Grievance redressal-cancel'
            : popupObj?.popupType === 'reopenTicket'
              ? 'reopen_cancel'
              : commentsPopup
                ? 'my tickets-view comments-cancel'
                : ''
        }`,
        `${getUserType?.[contractType]}-${
          enableGrievance
            ? 'Grievance redressal-cancel'
            : popupObj?.popupType === 'reopenTicket'
              ? 'reopen_cancel'
              : commentsPopup
                ? 'my tickets-view comments-cancel'
                : ''
        }`,
        `${getUserType?.[contractType]}-${
          enableGrievance
            ? 'Grievance redressal-cancel'
            : popupObj?.popupType === 'reopenTicket'
              ? 'reopen_cancel'
              : commentsPopup
                ? 'my tickets-view comments-cancel'
                : ''
        }`,
      );
    }
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = commentsPopup
        ? 'viewcomments_cancel'
        : enableGrievance
          ? 'grievance_cancel'
          : popupObj?.popupType === 'reopenTicket'
            ? 'reopen_cancel'
            : '';
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = ``;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    setPopup({});
  };

  const handleTicketCreate = async () => {
    onClickEvent(
      id === 'allTickets' ? 'CSFAQ Page' : 'Grievance page',
      id === 'allTickets' ? 'Raise CS Ticket' : 'Raise a ticket',
      id === 'allTickets' ? 'Raise CS Ticket' : 'Raise a ticket',
    );

    if (selectedBusiness?.parentid && selectedBusiness?.data_city) {
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = 'ticketcreation';
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = 'issue_grievance';
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
      if (['paid', 'expiredShort'].includes(contractType)) {
        navigate('/csportal/create_ticket');
      } else {
        navigate(
          `/csportal/create_ticket?parentId=${selectedBusiness.parentid}&city=${selectedBusiness.data_city}
&raiseTicketTrackerID=${id === 'grievance' ? 'gr' : ''}`,
        );
      }
    }
  };

  const handleOpenGrievanceRedressalPopup = () => {
    document.body.style.overflow = 'hidden';
    setPopup({
      open: true,
      popupType: 'GrievanceRedressal',
      heading: 'Grievance Redressal',
      subHeading:
        'In the event that you are not satisfied with the resolution provided by our team you can contact our grievance redressal officer.',
      placeholder: 'Please write your query here, and our Grievance Redressal team will act on it in 24-48 hours',
    });
  };

  const handleGrievanceEscalateBtn = async (index) => {
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `cta_${index === 0 ? 'illwait' : 'escalate'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = ``;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
    if (index === 1) {
      handleOpenGrievanceRedressalPopup();
    } else {
      setShowGrievanceData(false);
    }
  };

  const handleGrievanceClick = async (ticketData) => {
    setSelectedTicketData(ticketData);
    setEnableGrievance(true);
    setShowGrievanceData(true);
    if (trackUserType?.[contractType]) {
      await clickTracker(
        'options',
        contractType === 'user'
          ? id === 'mytickets_page'
            ? 'User_Mytickets_page'
            : 'User_Mytickets'
          : `${trackUserType?.[contractType]}_${
              id === 'allTickets' ? 'mytickets' : id === 'mytickets_page' ? 'mytickets_page' : ''
            }`,
      );
      if (projectId === 'csportal') {
        const liVal = 'click';
        const liTrd = `cta_grievance`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = ``;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    }
  };

  useClickAwayListener(reopenTicketRef, () => {
    handleClosePopup();
  });

  useClickAwayListener(commentsRef, () => {
    const commentsPopup = 1;
    handleClosePopup(commentsPopup);
  });

  useClickAwayListener(genioReopenRef, () => {
    document.body.style.overflow = 'unset';
    handleClosePopup();
  });

  const handleScroll = () => {
    if (myTicketsRef.current && !hasLogged) {
      const rect = myTicketsRef.current.getBoundingClientRect();
      if (rect.top <= window.innerHeight) {
        const liVal = 'impression';
        const liTrd = 'tickets_scroll';
        handleOnLanding(liVal, liTrd);
        setHasLogged(true);
      }
    }
  };
  useEffect(() => {
    if (trackPage === 'landing') {
      window.addEventListener('scroll', handleScroll);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [hasLogged]);

  return (
    <>
      <div id="__next">
        <div className="cs_page cs_ticketspage">
          <div className="p-20" ref={myTicketsRef}>
            <div className="cstickets_text">
              {!hideViewAll && id !== 'grievance' && myTicketsData.length > 0 && (
                <a
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {}}
                  onClick={async () => {
                    const liVal = 'click';
                    const liTrd = `view_all`;
                    handleOnLanding(liVal, liTrd, 'view_all');
                    navigate('/csportal/myTickets');
                    if (trackUserType?.[contractType]) {
                      await clickTracker(
                        'viewall',
                        contractType === 'user' ? 'User_Mytickets' : `${trackUserType?.[contractType]}_mytickets`,
                      );
                    }
                  }}
                  className="font13 fw500 color007 anchor"
                  style={{ float: 'right' }}
                >
                  View All
                </a>
              )}
              <div className="font13 fw500 color777">
                {id === 'grievance' && myTicketsData && myTicketsData.length > 0
                  ? "If you're not satisfied with the resolution provided on your complaint, then please select the concerned ticket below."
                  : id === 'allTickets'
                    ? 'My Tickets'
                    : ''}
              </div>
            </div>
            {id === 'grievance' && !hideViewAll && loading ? (
              <div className="loader-container">
                <div className="bt-spinner" />
              </div>
            ) : (
              <>
                {myTicketsData && myTicketsData.length > 0 ? (
                  <ul className={`${styles.Ticket_ListGroup} pt-15`}>
                    {myTicketsData &&
                      myTicketsData.map((each, idx) => {
                        let allowReopenTicket = each?.allowReopenTicket === true || false;
                        let transferId = '';
                        if (
                          projectId === 'csportal' &&
                          ['csportal', 'call', 'whatsapp'].includes(each?.src_typ) &&
                          each?.disposition?.toLowerCase() === 'transferred'
                        ) {
                          allowReopenTicket = false;
                          transferId =
                            each?.transfer_info && each?.transfer_info?.length > 0 && each?.transfer_info?.[0]
                              ? each?.transfer_info?.[0]?.to || ''
                              : '';
                        }
                        let CrOnDateTime = '';
                        let ClosedOnDateTime = '';
                        if (each.createdOn) {
                          CrOnDateTime = each.createdOn;
                        }
                        if (each.closeOn) {
                          ClosedOnDateTime = each.closeOn;
                        }
                        const becameEligible = each.isEscalationEligible;
                        const { isWithinVisibilityWindow } = each;

                        const showGrievanceRedressal =
                          projectId !== 'genio' && becameEligible && isWithinVisibilityWindow && each?.gr_raised !== 1;

                        // --- END LOGIC ---

                        return (
                          <li key={idx} className={`${styles.Ticket__ListGroupItem}`}>
                            <div
                              role="button"
                              tabIndex={0}
                              onKeyDown={() => {}}
                              onClick={() => {
                                if (id === 'grievance' && each?.gr_raised !== 1) {
                                  onClickEvent('Grievance ticket', 'Grievance-Ticket', 'Grievance ticket');
                                  setShowGrievanceData(true);
                                  setSelectedTicketData(each);
                                  setEnableGrievance(true);
                                }
                              }}
                            >
                              <div className="dflex pb-5">
                                <div className="font13 fw600 color111">
                                  {projectId === 'genio' ? each?.compnm || '' : each?.issue_type || ''}
                                </div>
                                <div className={`${styles.Ticket__ListGroupAction}`}>
                                  <div
                                    className={`font11 fw500 mr-10 ${
                                      each.status === 'OPEN'
                                        ? 'color339'
                                        : each.status === 'CLOSE_ESC' || each.status === 'CLOSED'
                                          ? 'colorEC4'
                                          : 'colorF3C'
                                    }`}
                                  >
                                    {each.status}
                                  </div>
                                  {showGrievanceRedressal && (
                                    <Tooltip text="Grievance Redressal" position="left">
                                      <div
                                        aria-label="grievance_click"
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={() => {}}
                                        onClick={() => handleGrievanceClick(each)}
                                        className={`csicon ${styles.Ticket__MoreIcon}`}
                                      >
                                        <div className={`${styles.Ticket__MoreBox} `} />
                                      </div>
                                    </Tooltip>
                                  )}
                                </div>
                              </div>
                              {projectId === 'genio' && (
                                <div className={`${styles.Ticket__ListGroupInfo} mt-4 font12 fw400 color777`}>
                                  {each?.issue_type || ''}
                                </div>
                              )}

                              <div
                                className={`${styles.Ticket__ListGroupInfo} mt-4 font12 fw400 color777`}
                                style={{ cursor: 'pointer', userSelect: 'text' }}
                              >
                                {`Ticket ${each?.ticket_id || ''} | ${CrOnDateTime}`}
                              </div>

                              {each.status === 'OPEN' || each.status === 'INPROGRESS' ? (
                                each.alloc_empnm &&
                                each.alloc_empnm !== 'AI Bot' && (
                                  <div className="font12 fw500 color777">Agent : {each.alloc_empnm}</div>
                                )
                              ) : (
                                <>
                                  <div className={`${styles.Ticket__ListGroupCmnt} mt-10`}>
                                    <div className={`csicon ${styles.Ticket__CommentIcon}`} />
                                    <div className="font12 fw400 color111 pl-8">Closed on {ClosedOnDateTime}</div>
                                  </div>

                                  {each.alloc_empnm && each.alloc_empnm !== 'AI Bot' && (
                                    <div className="font12 fw500 color777">Agent : {each.alloc_empnm}</div>
                                  )}
                                </>
                              )}

                              {transferId && (
                                <>
                                  <div className="font12 fw500 color777 mt-8">
                                    Your ticket has been transferred to another team for further support.
                                  </div>
                                  <div className="font12 fw500 color777 mt-4">Reference ticket Id: {transferId}</div>
                                </>
                              )}
                            </div>
                            {showGrievanceData &&
                              showGrievanceRedressal &&
                              selectedTicketData?.ticket_id === each?.ticket_id && (
                                <>
                                  <div className="font12 fw400 color111 mt-5">
                                    {each?.status === 'OPEN'
                                      ? 'You ticket is under process. Please wait or escalate it to our Grievance Redressal Officer.'
                                      : each?.status === 'CLOSE_ESC' || each?.status === 'CLOSED'
                                        ? 'Not happy with solution provided by our team? You can escalate concern to Grievance Redressal Officer.'
                                        : ''}
                                  </div>
                                  <div className={`${styles.Ticket__ListBtnGroup} mt-15`}>
                                    {['I’ll wait', 'Escalate'].map((eachBtn, i) => (
                                      <button
                                        onClick={() => handleGrievanceEscalateBtn(i)}
                                        key={i}
                                        type="button"
                                        className={`${styles.Ticket__ActionButton} ${
                                          i === 0 ? styles.Whitefill_animate : styles.Bluefill__animate
                                        } font13 fw600 ${i === 0 ? 'color007' : 'colorFFF'}`}
                                      >
                                        {eachBtn}
                                      </button>
                                    ))}
                                  </div>
                                </>
                              )}

                            {projectId !== 'genio' && each?.gr_raised === 1 && (
                              <div className="font12 fw500 colorFF6 mt-6">
                                {each.status === 'CLOSED' || each.status === 'CLOSED_ESC'
                                  ? 'Grievance resolved'
                                  : 'Grievance complaint registered'}
                              </div>
                            )}
                            <div className={`${styles.Ticket__ListBtnBox} pt-5 mt-15`}>
                              {(((each.status === 'OPEN' || each.status === 'INPROGRESS') && each.reopen_count > 0) ||
                                each.status === 'CLOSED' ||
                                each.status === 'CLOSED_ESC') && (
                                <button
                                  onClick={() => handleViewCommentsClick(each)}
                                  type="button"
                                  className={`${styles.Ticket__ListButton} font13 fw600 color007`}
                                >
                                  {each.alloc_empid === 'AI101' && projectId === 'genio'
                                    ? 'View AI Resolution'
                                    : 'View Comments'}
                                </button>
                              )}
                              {(each.status === 'CLOSED' || each.status === 'CLOSED_ESC') &&
                                each?.gr_raised !== 1 &&
                                allowReopenTicket && (
                                  <button
                                    onClick={() => handleReopenClick(each)}
                                    type="button"
                                    className={`${styles.Ticket__ListButton} font13 fw600 color007`}
                                  >
                                    Re-open Ticket
                                  </button>
                                )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                ) : (
                  <div className="font13 fw600 color111 no-tickets-heading">
                    {id === 'grievance' && myTicketsData && myTicketsData.length > 0
                      ? ''
                      : id === 'allTickets'
                        ? 'No tickets raised'
                        : ''}
                    {hideViewAll && !loading && 'Oops! No tickets found'}
                  </div>
                )}

                {id === 'grievance' && (
                  <>
                    <div className="font13 fw600 color111 mt-10 mb-10">
                      If you do not have a Complaint Ticket ID, then please visiting our
                      <span
                        role="button"
                        tabIndex={0}
                        onKeyDown={() => {}}
                        style={{ color: '#2D5FD4', margin: '0 2px' }}
                        onClick={() => {
                          onClickEvent('Grievance page', 'FAQ Section', 'FAQ Section');
                          navigate('/csportal');
                        }}
                      >
                        FAQs section
                      </span>
                      to find resolution to your issue.
                    </div>
                    <div className="text-center font13 fw600 color111">OR</div>
                    <div className="raiseticketwrp text_center pl-20 pr-20 mt-10">
                      <button
                        className={`${styles2.Accordion__Contant__Button} bluefill_animate font12 fw600 colorFFF mt-10`}
                        style={defaultEnableBtnStyles}
                        type="button"
                        id="complaintBtn"
                        onClick={() => {
                          handleTicketCreate();
                        }}
                      >
                        Raise a Complaint
                      </button>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>

        {popupObj?.popupType === 'genioReopenTicket' && (
          <GenioModal
            dispositionComment={dispositionComment}
            setDispositionComment={setDispositionComment}
            handleClosePopup={handleClosePopup}
            genioReopenRef={genioReopenRef}
            setAlert={setAlert}
            handleDispositionCommentSubmit={handleDispositionCommentSubmit}
            haveSubmitted={haveSubmitted}
          />
        )}

        {['reopenTicket', 'GrievanceRedressal'].includes(popupObj?.popupType) && (
          <CommonPopup
            comment={dispositionComment}
            setComment={setDispositionComment}
            handleCommentSubmit={handleDispositionCommentSubmit}
            handleClosePopup={handleClosePopup}
            haveSubmitted={haveSubmitted}
          />
        )}

        {popupObj?.popupType === 'ViewComments' && (
          <CommentsPopup
            commentsData={commentsData}
            commentsRef={commentsRef}
            handleClosePopup={handleClosePopup}
            aiSummary={aiSummary}
          />
        )}
      </div>
    </>
  );
}

MyTickets.propTypes = {
  myTicketsData: PropTypes.array,
  loading: PropTypes.bool,
  reloadMyTickets: PropTypes.func,
  hideViewAll: PropTypes.bool,
  id: PropTypes.string,
  handleOnLanding: PropTypes.func,
  trackPage: PropTypes.string,
};
